import React from 'react';
import Header from '../inc/header';
import Footer from '../inc/footer';
import { Helmet } from 'react-helmet-async';

function Locations() {
    return (
        <>
            <style type="text/css">
                {`
                .location-section {
                    background: #ffffff;
                    padding: 80px 0;
                }

                .location-header {
                    background-image: url('/assets/img/slides/page-header-services.jpg');
                    background-size: cover;
                    background-position: center;
                    color: white;
                    padding: 200px 0 80px;
                }

                .location-header h1 {
                    font-size: 48px;
                    font-weight: 700;
                }

                .map-container iframe {
                    border: none;
                    border-radius: 12px;
                    box-shadow: 0px 4px 10px rgba(0,0,0,0.15);
                }

                .card {
                    border-radius: 12px !important;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }

                .card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0px 6px 16px rgba(0,0,0,0.2);
                }

                @media (max-width: 991px) {
                    .map-container iframe {
                        height: 400px !important;
                    }
                }
                `}
            </style>

            <Helmet>
                <title>GSPWLL - Locations</title>
                <meta name="description" content="Find GSPWLL offices and locations worldwide." />
            </Helmet>

            <div className="body">
                <Header />

                {/* ===== Page Header ===== */}
                <section className="location-header text-center">
                    <div className="container">
                        <h1>Our Locations</h1>
                        <p className="mt-3 fs-5">
                            Explore our offices and contact us for global partnership opportunities.
                        </p>
                    </div>
                </section>

                {/* ===== Locations Section ===== */}
                <section className="location-section">
                    <div className="container-fluid" style={{ maxWidth: '90%' }}>
                        <div className="row g-5 align-items-start">
                            {/* ===== Left Side (Map) ===== */}
                            <div className="col-lg-8 map-container">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3576.7536805141435!2d50.211725412101494!3d26.30208407692065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49e924318ed8b9%3A0xa5d919fc3c2d8fdc!2sGulf%20Strategic%20Partners%20(GSP)!5e0!3m2!1sen!2s!4v1751365082752!5m2!1sen!2s"
                                    width="100%"
                                    height="600"
                                    allowFullScreen=""
                                    loading="lazy"
                                    title="GSP Map"
                                ></iframe>
                            </div>

                            {/* ===== Right Side (Cards) ===== */}
                            <div className="col-lg-4">
                                <div className="d-flex flex-column gap-4">
                                    {[
                                        {
                                            city: 'Manama, Bahrain',
                                            phone: '+973 1234 5678',
                                            address: 'Office 12, Diplomatic Area, Manama, Bahrain',
                                        },
                                        {
                                            city: 'Niš, Serbia',
                                            phone: '+381 11 832 303 75',
                                            address: 'Dimitrija Tucovica 31a, Floor 1, Niš, 18106 Serbia',
                                        },
                                        {
                                            city: 'Edmonton, Canada',
                                            phone: '+1 780 123 4567',
                                            address: 'Suite 102, Jasper Ave, Edmonton, AB, Canada',
                                        },
                                        {
                                            city: 'Dubai, UAE',
                                            phone: '+971 4 123 4567',
                                            address: 'Office 304, Business Bay, Dubai, UAE',
                                        },
                                    ].map((loc, i) => (
                                        <div key={i} className="card shadow-sm border-0">
                                            <div className="card-body">
                                                <h4 className="card-title fw-bold mb-2">{loc.city}</h4>
                                                <p className="text-danger fw-semibold mb-1">
                                                    Tel: {loc.phone}
                                                </p>
                                                <p className="text-muted mb-3">{loc.address}</p>

                                                <hr className="my-3" />
                                                <div className="d-flex gap-3">
                                                    <a
                                                        href={`tel:${loc.phone.replace(/ /g, '')}`}
                                                        className="btn btn-sm btn-outline-primary rounded-pill px-4"
                                                    >
                                                        Call
                                                    </a>
                                                    <a
                                                        href="mailto:info@gspwll.com"
                                                        className="btn btn-sm btn-outline-secondary rounded-pill px-4"
                                                    >
                                                        Message
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        </>
    );
}

export default Locations;
